import { AppContext } from '../../../../../components/app-context/app-context.tsx';
import { gql, GqlQuery } from '../../../../../components/graphql/gql-tag.ts';
import { IGraphQLQueryError } from '../../../../../components/graphql/graphql-service.ts';
import {
  OpenTableAvailabilityCheck,
  OpenTableAvailabilityCheckVariables,
  SaveTableBooking,
  SaveTableBookingVariables
} from '../../../../../types/graphql-types-generated.ts';

const gqlScriptOpenTableAvailabilityCheck: GqlQuery = {
  gqlQuery: gql`
    query OpenTableAvailabilityCheck(
      $restaurantId: Int!
      $date: String!
      $time: String!
      $partySize: Int!
    ) {
      checkOpenTableAvailability(
        restaurantId: $restaurantId
        date: $date
        time: $time
        partySize: $partySize
      ) {
        availableTimes {
          time
          bookingUrl
        }
        error
      }
    }
  `
};

const gqlScriptSaveTableBooking: GqlQuery = {
  gqlQuery: gql`
    mutation SaveTableBooking(
      $restaurantId: Int!
      $dateTime: String!
      $firstName: String!
      $lastName: String!
      $email: String!
      $phone: String!
      $numberOfPersons: Int!
      $annotation: String
      $userId: ID
      $privacyTermsAccepted: Boolean!
      $bookingTermsAccepted: Boolean!
      $registerUser: Boolean!
    ) {
      saveTableBooking(
        input: {
          restaurantId: $restaurantId
          dateTime: $dateTime
          firstName: $firstName
          lastName: $lastName
          email: $email
          phone: $phone
          numberOfPersons: $numberOfPersons
          userId: $userId
          annotation: $annotation
          privacyTermsAccepted: $privacyTermsAccepted
          bookingTermsAccepted: $bookingTermsAccepted
          registerUser: $registerUser
        }
      )
    }
  `
};

export const openTableAvailabilityCheck = (
  variables: OpenTableAvailabilityCheckVariables,
  appContext: AppContext
) => {
  return appContext.graphqlService.query<OpenTableAvailabilityCheck, IGraphQLQueryError>({
    query: gqlScriptOpenTableAvailabilityCheck,
    variables
  });
};

export const saveTableBooking = (variables: SaveTableBookingVariables, appContext: AppContext) => {
  return appContext.graphqlService.query<SaveTableBooking, IGraphQLQueryError>({
    query: gqlScriptSaveTableBooking,
    variables
  });
};
